import React from 'react';
import classnames from 'classnames';

import GetInTouch from '@react/Pages/AccountSettingsPage/YourDataSection/PricingPlanTile/GetInTouch';

import './AdditionalPackage.scss';

export interface AdditionalPackageProps {
  name: string;
  description: string;
  isEnabled?: boolean;
}

export const AdditionalPackage = ({ name, description, isEnabled }: AdditionalPackageProps) => {
  const packageContentClassNames = classnames('additional-package', 'flex-one', 'flex-box-column', {
    'additional-package--enabled': isEnabled,
  });

  return (
    <div className={packageContentClassNames}>
      <div className="flex-auto additional-package__title">
        <h3 className="additional-package__name">{name}</h3>
        <p className="additional-package__description">{description}</p>
      </div>
      <div className="additional-package__package-link">
        {isEnabled ? (
          <span className="btn additional-package__btn-placeholder">{t('label.in-use')}</span>
        ) : (
          <GetInTouch light />
        )}
      </div>
    </div>
  );
};
